import { motion } from "framer-motion";
import { Mail, MapPin, Clock, Phone } from "lucide-react";
import InquiryForm from "../components/InquiryForm";

export default function Contact() {
  return (
    <div data-testid="contact-page" className="pb-32">
      <section className="container-luxe pt-16 md:pt-24">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="mx-auto max-w-3xl text-center"
        >
          <span className="overline">Request Consultation</span>
          <h1 className="mt-5 font-[Cormorant_Garamond] text-5xl text-[#1A1D1A] md:text-6xl">
            Begin a confidential conversation.
          </h1>
          <div className="gold-divider mt-6" />
          <p className="mt-7 text-base leading-relaxed text-[#4A524C] md:text-lg">
            Own a property in the UK? Our practice lead will respond within one
            business day. Discovery calls are complimentary and always
            confidential.
          </p>
        </motion.div>
      </section>

      <section className="container-luxe mt-16 grid gap-12 lg:grid-cols-12">
        <div className="space-y-6 lg:col-span-4">
          <ContactItem
            icon={Mail}
            label="Email"
            value="info@sagita-llc.com"
            href="mailto:info@sagita-llc.com"
            testid="contact-info-email"
          />
          <ContactItem
            icon={Phone}
            label="Phone"
            value="+1 866 803 7635"
            href="tel:+18668037635"
            testid="contact-info-phone"
          />
          <ContactItem
            icon={MapPin}
            label="Registered Office"
            value="30 N Gould St Ste R, Sheridan, WY 82801, USA"
            testid="contact-info-office"
          />
          <ContactItem
            icon={Clock}
            label="Response"
            value="One business day · Mon – Sun"
            testid="contact-info-hours"
          />

          <div className="rounded-2xl border border-[#D9CFC2]/60 bg-white p-8 shadow-[0_8px_30px_rgba(26,29,26,0.04)]">
            <h3 className="font-[Cormorant_Garamond] text-2xl text-[#1A1D1A]">
              For portfolio &amp; family-office mandates
            </h3>
            <div className="mt-3 h-px w-10 bg-[#C6A66B]" />
            <p className="mt-4 text-sm leading-relaxed text-[#4A524C]">
              We take on a small number of multi-property mandates each year.
              If you own or advise on a UK residential portfolio, please
              mention it in your message and we will route you directly to our
              practice lead.
            </p>
          </div>
        </div>

        <div className="lg:col-span-8">
          <InquiryForm source="contact-page" />
        </div>
      </section>
    </div>
  );
}

function ContactItem({ icon: Icon, label, value, href, testid }) {
  const content = (
    <div className="flex items-start gap-4 rounded-2xl border border-[#D9CFC2]/60 bg-white p-6 transition-all hover:shadow-[0_8px_30px_rgba(26,29,26,0.06)]">
      <div className="grid h-12 w-12 flex-shrink-0 place-items-center rounded-full bg-[#F7F4ED] text-[#7A8C7B]">
        <Icon size={18} />
      </div>
      <div>
        <span className="overline">{label}</span>
        <p className="mt-1 font-[Cormorant_Garamond] text-xl text-[#1A1D1A]">
          {value}
        </p>
      </div>
    </div>
  );
  return href ? (
    <a href={href} data-testid={testid} className="block">
      {content}
    </a>
  ) : (
    <div data-testid={testid}>{content}</div>
  );
}
